module.exports = __webpack_public_path__ + "static/media/documents_icon_wh.212b5d1a.svg";